import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import RoleSubMenuFields from './RoleSubMenuFields'

export const RoleSubMenuEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <RoleSubMenuFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default RoleSubMenuEdit
